import { render, staticRenderFns } from "./RegularTables.vue?vue&type=template&id=82f966e8&scoped=true&"
import script from "./RegularTables.vue?vue&type=script&lang=js&"
export * from "./RegularTables.vue?vue&type=script&lang=js&"
import style0 from "./RegularTables.vue?vue&type=style&index=0&id=82f966e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f966e8",
  null
  
)

export default component.exports